/**
 * Coin Color Service - Brand colors for popular cryptocurrencies
 * 
 * Provides consistent color schemes for cryptocurrency icons and UI elements.
 */

// Brand colors for popular coins
const coinColors = {
  btc: '#f7931a',
  eth: '#627eea',
  usdt: '#26a17b',
  bnb: '#f3ba2f',
  sol: '#9945ff',
  ada: '#0033ad',
  xrp: '#23292f',
  dot: '#e6007a',
  doge: '#c2a633',
  matic: '#8247e5',
  avax: '#e84142',
  ltc: '#bfbbbb',
  link: '#2a5ada',
  uni: '#ff007a',
  atom: '#2e3148',
  etc: '#328332',
  xlm: '#08b5e5',
  trx: '#ff060a',
  xmr: '#ff6600',
  algo: '#000000',
  bch: '#8dc351',
  zec: '#f4b728',
  dash: '#008de4',
  vet: '#15bdff',
  fil: '#0090ff',
  shib: '#e42e2e',
  dai: '#f5ac37',
  busd: '#f0b90b',
  usdc: '#2775ca',
  aave: '#b6509e',
  comp: '#00d395',
  mkr: '#1aab9b',
  snx: '#00d1ff',
  grt: '#6747ed',
  crv: '#00d1ff',
  '1inch': '#1c324f',
  lrc: '#1a5aff',
  zil: '#49c1bf',
  neo: '#58bf00',
  qtum: '#2e9ad0',
  eos: '#443f54',
  xtz: '#2c7df7',
};

/**
 * Get the brand color for a cryptocurrency
 * @param {string} ticker - The cryptocurrency ticker symbol (e.g., 'btc', 'eth')
 * @returns {string} The brand color hex code or a default color
 */
export const getCoinColor = (ticker) => {
  if (!ticker) return '#3b82f6'; // Default blue
  return coinColors[ticker.toLowerCase()] || '#3b82f6';
};

/**
 * Get all available coin colors
 * @returns {Object} Map of ticker to color
 */
export const getAllCoinColors = () => {
  return { ...coinColors };
};

export default {
  getCoinColor,
  getAllCoinColors,
};
